import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  BrowserModule,
  HAMMER_LOADER,
  HammerModule,
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AtivacaoActionsComponent } from './components/ativacao-actions/ativacao-actions.component';
import {
  DialogAcessoSimulado,
  DialogAvisoAtv14Dias,
  DialogDescadastrarCliente,
  DialogEmail,
  DialogEncerrarAtivacao,
  DialogLigacao,
  DialogNotas,
  DialogSemConexao,
  DialogWhatsApp,
} from './components/dialogs/dialogs';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { ListHeadComponent } from './components/list-head/list-head.component';
import { MiniCardComponent } from './components/mini-card/mini-card.component';
import { NotasClienteComponent } from './components/notas-cliente/notas-cliente.component';
import { AngularFireUtilsModule } from './modules/angular-fire.module';
import { MaterialModule } from './modules/material.module';
import { UtilsModule } from './modules/utils.module';
import { CadastroVendedorComponent } from './pages/dashboard/cadastro-vendedor/cadastro-vendedor.component';
import { CampanhaComponent } from './pages/dashboard/campanha/campanha.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LembretesComponent } from './pages/dashboard/lembretes/lembretes.component';
import { PainelComponent } from './pages/dashboard/painel/painel.component';
import { PerfilComponent } from './pages/dashboard/perfil/perfil.component';
import { PesquisaClienteComponent } from './pages/dashboard/pesquisa-cliente/pesquisa-cliente.component';
import { EsqueciSenhaComponent } from './pages/login/esqueci-senha/esqueci-senha.component';
import { LoginComponent } from './pages/login/login.component';
import { GroupAtivacaoPipe } from './pipes/group-ativacao.pipe';
import { MomentPipe } from './pipes/moment.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { AtivacoesService } from './services/ativacoes.service';
import { AuthGuard } from './services/auth.guard';
import { CadastroVendedorService } from './services/cadastro-vendedor.service';
import { SecurityService } from './services/security.service';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    PainelComponent,
    GroupAtivacaoPipe,
    CampanhaComponent,
    MomentPipe,
    DialogEncerrarAtivacao,
    DialogWhatsApp,
    DialogEmail,
    DialogLigacao,
    DialogNotas,
    DialogSemConexao,
    DialogDescadastrarCliente,
    DialogAvisoAtv14Dias,
    PesquisaClienteComponent,
    AtivacaoActionsComponent,
    OrderByPipe,
    CadastroVendedorComponent,
    PerfilComponent,
    EsqueciSenhaComponent,
    NotasClienteComponent,
    LembretesComponent,
    DisclaimerComponent,
    ListHeadComponent,
    MiniCardComponent,
    DialogAcessoSimulado,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireUtilsModule,
    MaterialModule,
    UtilsModule,
    LayoutModule,
    HammerModule,
    NgxMaskModule.forRoot(options),
    HttpClientModule,
    NgxGoogleAnalyticsModule.forRoot('G-0NGYGJ200H'),
    InfiniteScrollModule,
    MatProgressSpinnerModule,
  ],
  providers: [
    AuthGuard,
    SecurityService,
    AtivacoesService,
    CadastroVendedorService,
    {
      provide: HAMMER_LOADER,
      useValue: async () => {
        return import('hammerjs/hammer');
      },
    },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR',
    },
    //{ provide: ORIGIN, useValue: 'http://localhost:5001' }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
